import styled from "@emotion/styled";

export const FilterButton = styled.div(({active, theme}) => ({
  backgroundColor: active ? theme?.colors?.brandBlue : "white",
  border: "none",
  color: active ? "white" : "black",
  maxHeight: 50,
  minHeight: 24,
  borderRadius: 8,
  padding: "8px 16px",
  cursor: "pointer",
  transform: "skew(-6deg)",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const Wrapper = styled.div(({theme, isSearch}) => ({
  gridColumn: "1/-1",
  display: "flex",
  marginTop: isSearch
    ? theme?.breakpoints?.isMobile
      ? 40
      : 30
    : theme?.breakpoints?.isMobile
      ? 32
      : 30,
  marginBottom: theme?.breakpoints?.isMobile ? 32 : 40,
  justifyContent: "center",
}));

export const FilterWrapper = styled.div(({theme}) => ({
  display: "flex",
  backgroundColor: theme?.colors?.primaryWhite,
  borderRadius: 8,
  transform: "skew(-6deg)",
  width: "fit-content",
  overflowX: theme?.breakpoints?.isMobile ? "auto" : "visible",
  whiteSpace: theme?.breakpoints?.isMobile ? "nowrap" : "normal",
  WebkitOverflowScrolling: theme?.breakpoints?.isMobile ? "touch" : "auto",
  scrollbarWidth: theme?.breakpoints?.isMobile ? "none" : "auto",
  msOverflowStyle: theme?.breakpoints?.isMobile ? "none" : "auto",
  boxShadow: " 0px 0px 32px 0px #1D314014",
  "&::-webkit-scrollbar": {
    display: theme?.breakpoints?.isMobile ? "none" : "auto",
  },
}));
